
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 21"}},[_c('path',{attrs:{"d":"M21 19.6l-5.7-5.7c1.2-1.5 1.9-3.3 1.9-5.3 0-4.7-3.9-8.6-8.6-8.6C3.9 0 0 3.9 0 8.6c0 4.7 3.9 8.6 8.6 8.6 2 0 3.8-.7 5.3-1.9l5.7 5.7 1.4-1.4zM8.6 15.2C5 15.2 2 12.2 2 8.6S5 2 8.6 2s6.6 2.9 6.6 6.6-3 6.6-6.6 6.6z"}})])
      }
    
      }
    